import { createConsoleLogger } from './baseLogger';
export let logger = createConsoleLogger();
export function setLogger(newLogger) {
    logger = newLogger;
}
